import { DocumentInteractionServiceImplementation } from "./documentInteractionSvc";

const EAE_INTERACTION_MODULE = angular.module("eaeInteraction", []);

EAE_INTERACTION_MODULE.service("documentInteractionService", DocumentInteractionServiceImplementation);
export default EAE_INTERACTION_MODULE;
